<template>
  <t-rich-select
    ref="botSelect"
    :key="refreshBotSelect"
    :options="botOptions"
    value-attribute="id"
    text-attribute="name"
    :value="selectedBotId"
    :open-on-focus="true"
    variant="botSelector"
    max-height="400"
    :hide-search-box="true"
    :close-on-select="true"
    @mouseover.native="updateHover(true)"
    @mouseleave.native="updateHover(false)"
    @blur="isDropdownOpen = false"
    @click="isDropdownOpen = !isDropdownOpen"
    @input="changeBot"
  >
    <template #option="{ option }">
      <div class="p-2">{{ option.text }}</div>
    </template>

    <template #label="{ option }">
      <with-loader id="bot-selector"
                   :loading="botsLoading"
                   use-as-overlay
                   :class="{ 'w-full': botsLoading }"
                   class="flex items-center gap-2"
      >

        <bot-icon :class="getColorClass()"/>
        <div class="w-40 truncate">
          {{ option.text }}
        </div>
      </with-loader>
    </template>

    <template #arrow>
      <sort-desc-icon class="transform transition-transform duration-500 text-primary background-primary"
                      :class="{ 'rotate-180': isDropdownOpen, 'hidden': botsLoading }"
                      order="desc"
                      :is-active="false"
      />
    </template>
  </t-rich-select>
</template>

<script>
import BotIcon from '@/assets/images/icons/BotIcon'
import botModule from '@/store/modules/bot.module'
import Template from '@/components/templates/Template'
import SortDescIcon from '@/components/common/SortableTableArrowsSort'
import sort from 'ramda/src/sort'
import WithLoader from '@/components/common/WithLoader'

export default {
  name: 'BotSelector',

  components: { Template, BotIcon, SortDescIcon, WithLoader },

  props: {
    defaultBotId: {
      type: String
    },
    optionsFilter: {
      type: Function,
      default: o => o
    }
  },

  data() {
    return {
      isHover: false,
      isDropdownOpen: false,
      refreshBotSelect: 0
    }
  },

  methods: {
    getColorClass() {
      return this.isHover ? 'text-primary' : 'text-gray-dark'
    },

    updateHover(isHover) {
      this.isHover = isHover
    },

    changeBot(botId) {
      this.isDropdownOpen = false
      if (!botId || this.selectedBotId === botId) return

      const bot = this.bots.find(bot => bot.id === botId)
      this.$emit('change', bot)

      // if change of bot fails, set an original bot and close dropdown
      if (this.selectedBotId !== botId) {
        const primaryBot = botModule.resolvePrimaryBot(botModule.getBot()?.id)
        if (primaryBot) this.$refs.botSelect.selectOption(primaryBot)
      }

      // this throws js error inside npm package, because for a brief moment this.$refs.button (there) is undefined
      // it doesn't seem any negative manifestation, need because of bot change after change dialog popup
      this.refreshBotSelect = Math.random()
    }
  },

  computed: {
    bots: botModule.getBotList,
    botsLoading: botModule.getBotLoading,

    selectedBotId() {
      return botModule.getPrimaryBotId()
    },

    botOptions() {
      const sorter = (a, b) => a.name.localeCompare(b.name)
      return sort(sorter, this.bots.filter(b => this.optionsFilter(b)))
    }
  },
  mounted() {
    const primaryBot = botModule.resolvePrimaryBot(this.defaultBotId)
    if (primaryBot) botModule.mergeBot(primaryBot)
  }
}
</script>

<style lang="scss">
#bot-selector {
  .effects {
    @apply border-gray;
    border-left: 3px solid #030D41 !important;
  }
}
</style>
